import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { GitHubIcon } from './SocialIcons';

const projects = [
  {
    title: "AI Matrix Platform",
    description: "A generative AI platform with real-time analysis and 3D data visualization.",
    tech: ["React", "Three.js", "Python", "FastAPI"],
    link: "!#",
    github: "!#",
    color: "#6366f1"
  },
  {
    title: "EcoCloud Dashboard",
    description: "Sustainability tracking dashboard for enterprise cloud infrastructure.",
    tech: ["Next.js", "TypeScript", "Node.js", "PostgreSQL"],
    link: "!#",
    github: "!#",
    color: "#ec4899"
  },
  {
    title: "Neural Network Viz",
    description: "Interactive visualization of hidden layers in deep learning models.",
    tech: ["Vue", "D3.js", "TensorFlow.js"],
    link: "!#",
    github: "!#",
    color: "#06b6d4"
  }
];

const Projects = () => {
  return (
    <section id="projects" className="container">
      <h2 className="section-title">Selected <span className="gradient-text">Projects</span></h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
            className="glass-card project-card"
          >
            <div className="project-header">
              <div className="project-icon" style={{ backgroundColor: project.color }}></div>
              <div className="project-links">
                <a href={project.github} className="icon-btn"><GitHubIcon size={20} /></a>
                <a href={project.link} className="icon-btn"><ExternalLink size={20} /></a>
              </div>
            </div>
            <h3 className="project-title">{project.title}</h3>
            <p className="project-desc">{project.description}</p>
            <div className="project-tags">
              {project.tech.map(t => <span key={t} className="tag">{t}</span>)}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
